"use client";

import { SDK } from "@frontend/roz-sdk-core";
import Cookies from "js-cookie";
import { useEffect } from "react";

import { useSdk, useSdkReady, useUser } from "@/provider";

const SOCIAL_PROVIDER_COOKIE = "social_prov";

export const SocialAuthTracker = () => {
  const ready = useSdkReady();
  const sdk = useSdk();
  const { user, isLoading } = useUser();

  useEffect(() => {
    if (!ready || isLoading) {
      SDK.log("social", "gate: waiting for ready/isLoading", {
        ready,
        isLoading,
      });
      return;
    }

    const liveAuthorized = sdk.auth.isUserAuthorized();

    if (liveAuthorized && !user) {
      SDK.log("social", "gate: waiting for liveAuthorized/user", {
        liveAuthorized,
        user,
      });
      return;
    }

    const socialProvider = Cookies.get(SOCIAL_PROVIDER_COOKIE);

    SDK.log("social", { socialProvider, user });

    if (socialProvider && user) {
      SDK.log("social", "auth_v2_auth_successful_transition", {
        socialProvider,
      });
      sdk.analytics.trackYmAnalytics("auth_v2_auth_successful_transition", {
        events: {
          block_AUTH_V2: {
            eventAction: "successful transition",
            eventLabel: "Успешная авторизация",
            eventContext: socialProvider,
            filters: "na",
            add_info: "na",
          },
        },
      });
    }

    Cookies.remove(SOCIAL_PROVIDER_COOKIE, {
      domain: ".znanierussia.ru",
      path: "/",
    });

    SDK.log("social", `delete ${SOCIAL_PROVIDER_COOKIE} cookie`);
  }, [ready, isLoading, user, sdk]);

  return null;
};
